import "../style/dashboard.css";

import React from "react";
import { useParams } from "react-router-dom";
import Dashboard from "../js/components/dashboard/Dashboard.react";

export default function DashboardPage() {
  const { userId } = useParams();
  return <Dashboard userId={userId} />;
}
